import React, { useState } from "react";
import { Typography, Box, Button, Alert } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';
import { getUserProfile, loginUser } from '../api/authApi';
import { clearAuthTokens, setAuthTokens } from '../utils/authStorage';
import '../CSS/LoginComponent/Login.css';

const AdminLoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Step 1: Login — get the JWT token
            const loginResult = await loginUser({ email, password });
            const token = loginResult?.token || loginResult?.accessToken || loginResult;
            const refreshToken = loginResult?.refreshToken;

            // Step 2: Fetch the real profile using the token
            // The token is saved first so axiosInstance interceptor picks it up
            setAuthTokens({ accessToken: token, refreshToken });
            const profileData = await getUserProfile();

            // Step 3: Check if the user is an admin
            if (profileData.userType !== 'admin') {
                clearAuthTokens();
                setError('Access denied. This portal is for admins only.');
                return;
            }

            // Step 4: Commit to context and redirect
            login(token, profileData, refreshToken);
            navigate('/admin/dashboard');
        } catch (err) {
            console.error(err);
            clearAuthTokens();
            setError('Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">

            <Typography variant="h3" fontFamily={"KAGE_DEMO_FONT Black"} className="logo-text">
                sejiwa
            </Typography>

            <Typography variant="body1" color="text.secondary" gutterBottom marginBottom={4}>
                Admin Portal Login
            </Typography>

            {error && (
                <Alert severity="error" sx={{ marginBottom: 2, width: '100%' }}>
                    {error}
                </Alert>
            )}

            <form onSubmit={handleLogin} style={{ width: '100%' }}>
                <div className="input-wrapper">
                    <div className="email-container">
                        <EmailIcon className="input-icon" />
                        <input
                            type="email"
                            placeholder="Admin Email"
                            className="input-field"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>
                </div>

                <div className="input-wrapper">
                    <div className="password-container">
                        <LockIcon className="input-icon" />
                        <input
                            type="password"
                            placeholder="Password"
                            className="input-field"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>
                </div>

                <Button
                    type="submit"
                    variant="contained"
                    disableElevation
                    disabled={loading}
                    sx={{
                        width: "100%",
                        textTransform: "none",
                        backgroundColor: "#55C2C3",
                        borderRadius: "30px",
                        paddingY: "10px",
                        fontSize: "16px",
                        marginTop: "30px",
                        marginBottom: "30px",
                        "&:hover": { backgroundColor: "#48A6A7", transition: "0.3s" }
                    }}
                >
                    {loading ? 'Logging In...' : 'Login as Admin'}
                </Button>


            </form>
        </div>
    );
};

export default AdminLoginPage;
